module.exports = __webpack_public_path__ + "fonts/GT-Regular.4ac4cbee.otf";